import React from 'react';
import './Footer.css';

/*======================================================================
// This stateless functional component will display the footer.
======================================================================*/
const Footer = () => {
    return (
        <footer className="footer">
            <p>Made by <a href="http://www.jonathanleack.com/" target="_blank" rel="noopener noreferrer" alt="Jonathan Leack portfolio">Jonathan Leack</a></p>
        </footer>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Layout/Footer/Footer.js